const OpenSignBoxAction = (data: any) => (dispatch: any) => {
  if (data) {
    dispatch({
      type: 'SIGNUPBOX',
      payload: true,
    });
  } else {
    dispatch({
      type: 'SIGNUPBOX',
      payload: false,
    });
  }
};

export default OpenSignBoxAction;
